import * as Paths from '~/components/router/constants.js';

const UNAUTHENTICATED_PATHS = [
	Paths.ROUTE_LOGIN,
	Paths.ROUTE_REGISTER,
	Paths.ROUTE_RESET_PASSWORD,
	Paths.ROUTE_RESET_PASSWORD_EMAIL,
	Paths.ROUTE_RESET_PASSWORD_PHONE,
	Paths.ROUTE_RESET_PASSWORD_CODE,
	Paths.ROUTE_RESET_PASSWORD_DOB_VERIFICATION,
	Paths.ROUTE_RESET_PASSWORD_WELCOME,
	Paths.ROUTE_NEW_PASSWORD,
	Paths.ROUTE_PLAY_NOW,
	Paths.ROUTE_PLAY_NOW_BANKID,
	Paths.ROUTE_PLAY_AS_GUEST,
	Paths.ROUTE_COOKIE_POLICY,
	Paths.ROUTE_PLAY_NOW_DGA
];

export default UNAUTHENTICATED_PATHS;
